import { render, staticRenderFns } from "./counterparty_add.vue?vue&type=template&id=aad803dc&scoped=true&"
import script from "./counterparty_add.vue?vue&type=script&lang=js&"
export * from "./counterparty_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad803dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aad803dc')) {
      api.createRecord('aad803dc', component.options)
    } else {
      api.reload('aad803dc', component.options)
    }
    module.hot.accept("./counterparty_add.vue?vue&type=template&id=aad803dc&scoped=true&", function () {
      api.rerender('aad803dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/counterparty/counterparty_add.vue"
export default component.exports